import { useCreateQueryKeys as e } from "@maat/store-hooks";
//#region src/recentlyViewed/useRecentlyViewedQueryKeys.ts
var t = e("recentlyViewed", { list: (e) => e ? ["list", e] : ["list"] });
//#endregion
export { t as recentlyViewedQueryKeys };
